import React from 'react';
import AuctionSwitcher from './components/AuctionSwitcher';
import FaqSection from './components/Faq';
import Statistics from './components/Statistics';
import AppDownloadSection from './components/AppDownloadSection';
import { HomeBanner } from '../../homeBanner';
import PartnersSectionNew from './components/OurPartnerNew';
import BannerNew from './components/Banner';
import { TodayAuction } from '../../components/AuctionsCategory/TodayAuction';
import { PreviousAuctionNew } from '../../components/AuctionsCategory/PreviousAuction';
import { MyAuctionsSection } from '../../components/AuctionsCategory/MyAuctions';

const is_logged = localStorage.getItem('is_logged_in') ? true : false;

export class LandingPage extends React.Component {
    constructor() {
        super();
        const params = new URLSearchParams(window.location.search);
        this.state = {
            timeFilter: params.get('timeFilter') || 'all',
        };
        this.previousAuctionRef = React.createRef();
        this.handleTimeFilterChange = this.handleTimeFilterChange.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        // Read URL on mount and scroll if needed
        const params = new URLSearchParams(window.location.search);
        const timeFilter = params.get('timeFilter');
        if (timeFilter === 'previous') {
            // Delay to wait for full render
            setTimeout(() => {
                this.scrollToPrevious();
            }, 600);
        }
    }

    scrollToPrevious() {
        if (this.previousAuctionRef.current) {
            this.previousAuctionRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    }

    handleTimeFilterChange(timeFilter) {
        this.setState({ timeFilter });

        // Update URL
        const url = new URL(window.location);
        if (timeFilter && timeFilter !== 'all') {
            url.searchParams.set('timeFilter', timeFilter);
        } else {
            url.searchParams.delete('timeFilter');
        }
        window.history.replaceState({}, '', url);

        if (timeFilter === 'previous') {
            // Small delay to ensure state is set
            setTimeout(() => {
                this.scrollToPrevious();
            }, 100);
        }
    }

    render() {
        return (
            <div>
                <BannerNew />
                <AuctionSwitcher onTimeFilterChange={this.handleTimeFilterChange}/>
                <MyAuctionsSection onTimeFilterChange={this.handleTimeFilterChange}/>
                <TodayAuction onTimeFilterChange={this.handleTimeFilterChange} />
                <div ref={this.previousAuctionRef}>
                    <PreviousAuctionNew />
                </div>

                <FaqSection />
                <Statistics />
                <PartnersSectionNew />
                <AppDownloadSection />
            </div>
        );
    }
}